import React, { useState } from 'react'

import { styled } from '@material-ui/core/styles'
import { IconButton } from '@material-ui/core'
import { Menu } from '@material-ui/icons'
import { Drawer, List, ListItem, ListItemText } from '@material-ui/core'

import { Link } from 'components'

import menu from './menu'

const StyledListItemText = styled(ListItemText)({
  textDecoration: `none`,
  color: 'black',
})

const HamburgerMenu = () => {
  const [open, setOpen] = useState(false)
  const toggleDrawer = () => {
    setOpen((open) => !open)
  }
  return (
    <>
      <IconButton edge="start" aria-label="menu" onClick={toggleDrawer}>
        <Menu />
      </IconButton>
      <Drawer
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
      >
        <div role="presentation">
          <List component="nav">
            {menu.map(({ label, to }) => (
              <Link to={to} key={label}>
                <ListItem button>
                  <StyledListItemText primary={label} />
                </ListItem>
              </Link>
            ))}
          </List>
        </div>
      </Drawer>
    </>
  )
}

export default HamburgerMenu
